










 

 



























const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "clientId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "serverBaseUrl",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GitLabProviderRowTeamMember",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMemberIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GitLabIntegration",
          "kind": "LinkedField",
          "name": "gitlab",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamMemberIntegrationAuthOAuth2",
              "kind": "LinkedField",
              "name": "auth",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationProviderOAuth2",
                  "kind": "LinkedField",
                  "name": "provider",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "scope",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationProviderOAuth2",
              "kind": "LinkedField",
              "name": "cloudProvider",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationProviderOAuth2",
              "kind": "LinkedField",
              "name": "sharedProviders",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamMember",
  "abstractKey": null
};
})();

(node ).hash = "7ba5e0f5531595e2e618a26bcae935a2";

export default node;
